import { Routes } from '@angular/router';
import { CentrexUsersComponent } from 'src/app/components/centrex-users/centrex-users.component';
import { DashboardComponent } from 'src/app/components/dashboard/dashboard.component';
import { DevicesComponent } from 'src/app/components/devices/devices.component';
import { ExtensionsComponent } from 'src/app/components/extensions/extensions.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { RedirectionsComponent } from 'src/app/components/redirections/redirections.component';
import { SdasComponent } from 'src/app/components/sdas/sdas.component';
import { AuthGuard } from 'src/app/services/guards/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', pathMatch: 'full', redirectTo: '/dashboard' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'centrex-users',
    component: CentrexUsersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'extensions',
    component: ExtensionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sdas',
    component: SdasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'redirections',
    component: RedirectionsComponent,
    canActivate: [AuthGuard],
  },
   {
    path: 'devices',
    component: DevicesComponent,
    canActivate: [AuthGuard],
  },
];
